import React from 'react'
import { graphql } from 'gatsby'
import style from './video.mod.scss'
import { Modal } from '@components'
import Img from 'gatsby-image'

const Video = ({
  moduleStyle = 'Default',
  video,
  image,
  imageOptions,
  elevated = true,
  radius = true,
  ...props
}) => {
  const modifiers = [
    style['video--' + moduleStyle.toLowerCase().replace(/ /gi, '-')]
  ]
  !image && modifiers.push(style['video--no-image'])
  !elevated && modifiers.push(style['video--no-elevated'])
  !radius && modifiers.push(style['video--no-radius'])

  return (
    <div className={[style.video, ...modifiers].join(' ')}>
      <div className={style.video__wrap}>
        {image ? (
          <Img className={style.video__image} fluid={image.fluid} />
        ) : (
          <div className={style.video__placeholder} />
        )}
        <Modal video={video} placement="center" />
      </div>
    </div>
  )
}

export default Video

export const query = graphql`
  fragment VideoWithContent on DatoCmsVideoWithContent {
    background
    backgroundStyle
    padding
    heading
    contentNode {
      childMarkdownRemark {
        html
      }
    }
    heading
    id
    link {
      ...Link
    }
    moduleStyle
    model {
      apiKey
    }
    image: overlay {
      fluid(maxWidth: 600, imgixParams: { fit: "crop", w: "600", h: "490" }) {
        ...GatsbyDatoCmsFluid
      }
    }
    video: url {
      url
      title
      provider
      providerUid
      thumbnailUrl
      width
      height
    }
  }

  fragment Video on DatoCmsVideo {
    background
    padding
    heading
    leadNode {
      childMarkdownRemark {
        html
      }
    }
    heading
    id
    link {
      ...Link
    }
    model {
      apiKey
    }
    image: overlay {
      fluid(maxWidth: 970, imgixParams: { fit: "crop", w: "970", h: "550" }) {
        ...GatsbyDatoCmsFluid
      }
    }
    video: url {
      url
      title
      provider
      providerUid
      thumbnailUrl
      width
      height
    }
  }
`
